import _ from 'lodash';

function MLAvailableInsuredCandidatesUtil() {

    const filterAvailableAutoInsuredCandidates = (submissionVM, addedInsuredCandidatesList) => {
        const availableInsuredCandidates = _.get(submissionVM, 'lobData.personalAuto.coverables.availableInsuredCandidates_Ext.value', []);

        const filteredAvailableInsuredCandidates = availableInsuredCandidates.filter((availableInsuredCandidate) => {
            return !addedInsuredCandidatesList.some((driver) => 
                (driver.publicID && availableInsuredCandidate.publicID && driver.publicID === availableInsuredCandidate.publicID) ||
                (driver.person && availableInsuredCandidate.person && driver.person.publicID === availableInsuredCandidate.person.publicID)
            );
        });
        _.set(submissionVM, 'lobData.personalAuto.coverables.availableInsuredCandidates_Ext.value', filteredAvailableInsuredCandidates);
    };

    const filterAvailableUmbrellaInsuredCandidates = (submissionVM, addedInsuredCandidatesList) => {
        const availableInsuredCandidates = _.get(submissionVM, 'lobData.personalUmbrella.coverables.availableInsuredCandidates_Ext.value', []);

        const filteredAvailableInsuredCandidates = availableInsuredCandidates.filter((availableInsuredCandidate) => {
            return !addedInsuredCandidatesList.some((driver) => 
                (driver.publicID && availableInsuredCandidate.publicID && driver.publicID === availableInsuredCandidate.publicID) ||
                (driver.contact && availableInsuredCandidate.contact && driver.contact.publicID === availableInsuredCandidate.contact.publicID)
            );
        });
        _.set(submissionVM, 'lobData.personalUmbrella.coverables.availableInsuredCandidates_Ext.value', filteredAvailableInsuredCandidates);
    };
        const removeDriverFromAvailableCandidates=(driver)=>{
                   const availableInsuredCandidates = _.get(submissionVM, 'lobData.personalAuto.coverables.availableInsuredCandidates_Ext.value', []);
                
                const driverPersonPublicID =
                    _.get(driver, 'person.publicID') || _.get(driver, 'publicID');
        
                const filteredAvailableInsuredCandidates = availableInsuredCandidates.filter((candidate) => {
                    const candidatePersonPublicID =
                        _.get(candidate, 'person.publicID') || _.get(candidate, 'publicID');
        
                    return candidatePersonPublicID !== driverPersonPublicID;
                });
        
                _.set( submissionVM, 'lobData.personalAuto.coverables.availableInsuredCandidates_Ext.value', filteredAvailableInsuredCandidates);
            };
           

    const addRemovedDriverToAvailableCandidates = (submissionVM, driver) => {
        const availableInsuredCandidates = _.get(submissionVM, 'lobData.personalAuto.coverables.availableInsuredCandidates_Ext.value', []);
        const driverExists = availableInsuredCandidates.some((candidate) => 
            candidate.person && candidate.person.publicID && driver.person && driver.person.publicID && 
            candidate.person.publicID === driver.person.publicID
        );
        if (!driverExists) {
            availableInsuredCandidates.push(driver);
        }
        _.set(submissionVM, 'lobData.personalAuto.coverables.availableInsuredCandidates_Ext.value', availableInsuredCandidates);
    };

    const addRemovedVehicleOperatorToAvailableCandidates = (submissionVM, vehicleOperator) => {
        const availableInsuredCandidates = _.get(submissionVM, 'lobData.personalUmbrella.coverables.availableInsuredCandidates_Ext.value', []);
        const driverExists = availableInsuredCandidates.some((candidate) => 
            candidate.contact && candidate.contact.publicID && vehicleOperator.contact && vehicleOperator.contact.publicID && 
            candidate.contact.publicID === vehicleOperator.contact.publicID
        );
        if (!driverExists) {
            availableInsuredCandidates.push(vehicleOperator);
        }
        _.set(submissionVM, 'lobData.personalUmbrella.coverables.availableInsuredCandidates_Ext.value', availableInsuredCandidates);
    };
    
    const addRemovedWatercraftOperatorToAvailableCandidates = (submissionVM, watercraftOperator) => {
        addRemovedVehicleOperatorToAvailableCandidates(submissionVM, watercraftOperator);
    }


    return {
        filterAvailableAutoInsuredCandidates,
        filterAvailableUmbrellaInsuredCandidates,
        removeDriverFromAvailableCandidates,
        addRemovedDriverToAvailableCandidates,
        addRemovedVehicleOperatorToAvailableCandidates,
        addRemovedWatercraftOperatorToAvailableCandidates
    };
}

export default MLAvailableInsuredCandidatesUtil;
